


const APIHOST = (process.env.NODE_ENV === "development1") ? "http://localhost:3000/dev" : "https://api.streempay.com";

function handleErrors(response) {
    if (!response.ok) {
        throw response;
    }
    return response;
}

export function getToken(data) {
    console.log('GETTING TOKEN...', data);
    return fetch(APIHOST + "/auth", {method: 'POST', body: JSON.stringify(data) })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('ERR', err);
            return "Invalid Credentials";
        });
    
}

export function getFbToken(data) {
    console.log('GETTING FB TOKEN...', data);
    return fetch(APIHOST + "/fb-auth", {method: 'POST', body: JSON.stringify(data) })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });
    
}

export function resetPassword(data) {
    console.log('RESET PASSWORD REQUEST...', data);
    return fetch(APIHOST + "/auth/forgot-password", {method: 'POST', body: JSON.stringify(data) })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('ERR', err);
            return "Invalid Credentials";
        });
}